import pinia from "@/stores/index.js";
import { defineStore } from "pinia";

const useUserStore = defineStore("user", {
  state: () => {
    return { user: {} };
  },
});

export const storeUser = useUserStore(pinia);
